import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import {
  Autocomplete,
  Container,
  Grid,
  Button,
  FormControl,
  FormGroup,
  FormControlLabel,
  Typography,
  TextField,
  Paper,
  MenuItem,
  Checkbox,
  IconButton,
  InputLabel,
  Input
} from "@mui/material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { DatePicker } from "@mui/x-date-pickers-pro";
import { useNavigate, useParams } from "react-router-dom";
import { usePrompt } from "../../../../../../common/usePrompt"
import Confirmation from "../../../../../../common/Comfirmation";
import {
  GetStudy,
  UpdateConsult,
  GetOrg,
  UpdateStudy,
  SendStudy,
  SendMobile,
  GetPriorities,
} from "../../../../../../api";
import RichText from "../../../../../../common/EditorMCE";
import {
  GENDER_OPTIONS,
  SPECIES_OPTIONS,
  PRIORITIES
} from "../../../../../../constants/Consult";
import FileDrop from "../../../shared/fileDrop";
import ConsultAlertDialog from "../../../shared/ConsultAlertDialog";
import moment from "moment";
import dayjs from 'dayjs';
import TextFieldsIcon from '@mui/icons-material/TextFields';

const emailTest = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
const orgsDefault = [{ id: '62a5265ffac787a63025a95a', name: 'South Sound Veterinary Imaging' }, { id: '63f6af940768bc34a1875cca', name: 'Cardiology-SSVI' }, { id: '65aee8888bfb716cc1ede82b', name: 'SSVI IM' }]
let changeTimeout
const systemDefaultFields = [
  { label: "Clinical History" },
  { label: "Questions to be answered" },
  { label: "Date of previous imaging/report (if applicable)" },
  { label: "*Internal Notes" },
]
const compareFields = (a,b) => {
  if (!Array.isArray(a))
    a = []
  if (!Array.isArray(b))
    b = []
  return (a.map(e=>(e.label || e)).join('|') === b.map(e=>(e.label || e)).join('|') ? true : false)
} 

const isEditorAlive = editor => editor && !editor.destroyed && editor.getBody()
const isEditorEmpty = editor => {
  if (!isEditorAlive(editor)) return true
  return editor.getContent({ format: 'text' }).trim() === '' && !editor.getBody().querySelector('img');
}

const StudyConsult = ({ user, access, edit }) => {

  const params = useParams()
  const [content, setContent] = useState([])
  const [study, setStudy] = useState(false);
  const [open, setOpen] = useState(false);
  const [newField, setNewField] = useState("");
  const [orgs, setOrgs] = useState();
  const [org, setOrg] = useState("");
  const [orgSettings, setOrgSettings] = useState()
  const [associateOrg, setAssociateOrg] = useState();
  const [associateOrgs, setAssociateOrgs] = useState();
  const [requestees, setRequestees] = useState([]);
  const [clinicRequestees, setClinicRequestees] = useState()
  const [requestee, setRequestee] = useState();
  const [billing, setBilling] = useState([]);
  const [billingCodes, setBillingCodes] = useState();
  const [priority, setPriority] = useState('');
  const [priorities, setPriorities] = useState([])
  const [customPriorities, setCustomPriorities] = useState(null)
  const [emails, setEmails] = useState()
  const [emailOptions, setEmailOptions] = useState([])
  const [numImages, setNumImages] = useState('');
  const [numImagesUnknown, setNumImagesUnknown] = useState(false);
  const navigate = useNavigate();
  const [changes, setChanges] = useState(true);
  const [media, setMedia] = useState([]);
  const [autoSave, setAutoSave] = useState()
  const autoSaveRef = React.useRef(false)
  const [defaultFields, setDefaultFields] = useState([])
  const [confirm, setConfirm] = useState({
    open: false,
    text: "",
    callback: undefined
  })
  const [consultError, setConsultError] = useState()
  const [ageYears, setAgeYears] = useState('')
  const [ageMonths, setAgeMonths] = useState('')
  const [ageDays, setAgeDays] = useState('')
  const [mobileFields, setMobileFields] = useState()
  const [mobileStudy, setMobileStudy] = useState()
  const [consultAlertOpen, setConsultAlertOpen] = useState(false)
  const pendingSendRef = useRef(null)

  const didRun = useRef(false); // Prevent double render in dev mode
  const clinicFields = useRef()

  const updateValues = useCallback((value, name) => {
    setStudy((prev) => {
      let p = { ...prev },
        obj = name.split(".");
      if (obj.length > 1)
        if (obj[0] in p) p[obj[0]] = { ...p[obj[0]], [obj[1]]: value };
        else p[obj[0]] = { [obj[1]]: value };
      else p[obj[0]] = value;
      return p;
    });
  }, [])

  const updateAgeFields = useCallback((birthDate) => {
    if (birthDate) {
      const duration = moment.duration(moment().diff(birthDate))
      setAgeYears(duration.years())
      setAgeMonths(duration.months())
      setAgeDays(duration.days())
    } else {
      setAgeYears('')
      setAgeMonths('')
      setAgeDays('')
    }
  }, [])

  const updateBirthDateFromAge = useCallback((years, months, days) => {
    const y = parseInt(years) || 0
    const m = parseInt(months) || 0
    const d = parseInt(days) || 0
    const birthDate = moment().subtract(y, 'years').subtract(m, 'months').subtract(d, 'days').format('YYYYMMDD')
    setStudy((prev) => {
      let p = { ...prev }
      if ('PatientMainDicomTags' in p) p.PatientMainDicomTags = { ...p.PatientMainDicomTags, PatientBirthDate: birthDate }
      else p.PatientMainDicomTags = { PatientBirthDate: birthDate }
      return p
    })
  }, [])

  const confirmOk = () => {
    confirm.callback && confirm.callback()
    confirmCancel()
  }
  const confirmCancel = () => {
    setConfirm(
      (i) => (i = { open: false, text: "", callback: undefined })
    )
  }

  const completeRequired = useMemo(() => {
    const hasPrio = customPriorities ? customPriorities.length : (priorities && priorities.length)
    if (associateOrg && user.settings?.orgSend && associateOrg !== access.org.id)
      return false
    return (
      org &&
      ((hasPrio && (priority || priority === 0)) || !hasPrio) &&
      (numImagesUnknown || (numImages || numImages === 0)) &&
      study.MainDicomTags.StudyDescription &&
      study.PatientMainDicomTags.ResponsiblePerson &&
      study.PatientMainDicomTags.PatientName &&
      study.PatientMainDicomTags.PatientID &&
      study.PatientMainDicomTags.PatientSex &&
      study.PatientMainDicomTags.PatientBirthDate &&
      study.PatientMainDicomTags.PatientSpeciesDescription &&
      study.PatientMainDicomTags.PatientBreedDescription &&
      study.PatientMainDicomTags.PatientWeight &&
      (!orgSettings?.requireBilling || billing?.length) &&
      (!orgSettings?.requirePhysician || study.MainDicomTags.ReferringPhysicianName)
    )
  }, [org, priorities, customPriorities, priority, numImages, numImagesUnknown, study, user, associateOrg, billing, orgSettings, access])

  const expectedNumImages = useMemo(() => {
    let i = study.instanceCount || 0
    if (study.media?.length)
      i += study.media.length
    return i
  }, [study])

  const updateOrg = useCallback((v, loading, mobile) => {
    if (org !== v) {
      setOrg(v)
      setPriority('')
      setBilling([])
      setRequestee()
      GetOrg(v).then(resp => {
        setOrgSettings(resp.settings)
        setRequestees(resp.users)
        setBillingCodes(resp.billing || [])
        setPriorities(resp.priorities || [])
        GetPriorities(v).then(cp => setCustomPriorities(cp?.length ? cp : null)).catch(() => setCustomPriorities(null))
        const hasConsultFields = Array.isArray(resp.settings?.consultFields) && resp.settings.consultFields.length
        const hasMobileConsultFields = (mobileStudy || mobile) && Array.isArray(resp.settings?.mobileConsultFields) && resp.settings.mobileConsultFields.length
        setMobileFields(hasMobileConsultFields)
        const editorEmpty = !content.length || !content.filter(e=>e.ref?.current).some(e=>!isEditorEmpty(e.ref.current))
        const newFields = (hasMobileConsultFields ? resp.settings.mobileConsultFields.map(label=>({label})) :  (hasConsultFields ? resp.settings.consultFields.map(label=>({label})) : systemDefaultFields))
        setDefaultFields(newFields)
        if (!loading && (hasMobileConsultFields || !clinicFields.current) && !compareFields(newFields, content) && editorEmpty) setContent(()=>newFields)
      }).catch(e => e)
    }
  }, [org, content, mobileStudy])

  useEffect(() => {
    try {
      if (localStorage)
        setEmailOptions(JSON.parse(localStorage.getItem('clinicConsultEmails')) || [])
    } catch (e) { }
  }, [])

  const saveEmailOptions = useCallback(() => {
    try {
      if (localStorage) {
        const emailOptionsCopy = [...emailOptions]
        emails.forEach(e => emailOptionsCopy.find(e2 => e.toLowerCase() === e2.toLowerCase()) || emailOptionsCopy.push(e))
        localStorage.setItem('clinicConsultEmails', JSON.stringify(emailOptionsCopy))
      }
    } catch (e) { }
  }, [emailOptions, emails])

  //const editorsNotEmpty = useCallback(() => content.filter(e=>e.ref?.current).some(e=>!isEditorEmpty(e.ref.current)), [content])

  const updateConsult = useCallback(() => {
    const report = content.filter(e=>e.ref?.current).map(e=>({label: e.label, html: (!isEditorEmpty(e.ref.current) && e.ref.current.getContent()) || null}))
    const requesteeIds = (requestee?.length && requestee.map(e => e.id)) || null
    const isRefPriority = customPriorities && typeof priority === 'string' && priority.length === 24
    return UpdateConsult(study.id, { org, report, associateOrg, requestee: requesteeIds, priority: isRefPriority ? null : priority, priorityRef: isRefPriority ? priority : null, numImages: numImagesUnknown ? 0 : numImages, media, billing: billing.map(e => e.id), emails, edit, autoSave: autoSaveRef.current }).then(() => setChanges(false)).then(() =>
      UpdateStudy(study.id, {PatientMainDicomTags: study.PatientMainDicomTags, MainDicomTags: study.MainDicomTags, autoSave: true}).catch(e => e)
    ).catch(e => e)
  }, [study, org, content, associateOrg, requestee, priority, customPriorities, numImagesUnknown, numImages, media, billing, emails, edit])

  const goBack = useCallback(num => {
    if (window.history.state && window.history.state.idx > 0) navigate(num)
    else navigate('/', { replace: true })
  }, [navigate])

  useEffect(() => {
    if (!didRun.current && params.studyId !== study?.id) {
      didRun.current = true
      GetStudy(params.studyId).then(resp => {
        setMobileStudy(resp.mobile)
        setDefaultFields(systemDefaultFields)
        clinicFields.current = false

        const clinicAccess = resp.aetitle && user.access.find(x =>
          (Array.isArray(x.org.aetitle) && x.org.aetitle.includes(resp.aetitle))
          || x.org.aetitle === resp.aetitle
        )

        const clinicOrg = resp.associateOrg || clinicAccess?.org
        if (!clinicOrg) return setConsultError("You do not have consult access to studies from this organization.")
        setClinicRequestees(!!clinicOrg.users?.length && clinicOrg.users)
        
        const hasConsult = Array.isArray(resp.consult) && resp.consult.length
        const hasConsultFields = Array.isArray(clinicOrg?.settings?.consultFields) && clinicOrg.settings.consultFields.length
        const hasMobileConsultFields = resp.mobile && Array.isArray(clinicOrg?.settings?.mobileConsultFields) && clinicOrg.settings.mobileConsultFields.length
        setContent(() => {
          if (hasConsult) return resp.consult
          else if (hasMobileConsultFields) {
            clinicFields.current = true
            return clinicOrg.settings.mobileConsultFields.map(label=>({label}))
          }  
          else if (hasConsultFields) {
            clinicFields.current = true
            return clinicOrg.settings.consultFields.map(label=>({label}))
          }
          return defaultFields
        })
        
        if (resp.org)
          updateOrg(resp.org.id, hasConsult, resp.mobile)
        setPriority(resp.priorityRef?.id || resp.priorityRef || resp.priority)
        if (resp.numImages === 0)
          setNumImagesUnknown(true)
        else
          setNumImages(resp.numImages || '')
        if (resp.requestee || resp.requestee === 0) setRequestee(Array.isArray(resp.requestee) ? resp.requestee.length && resp.requestee  : [resp.requestee])
        resp.billing && setBilling(resp.billing)
        resp.media && setMedia(resp.media)
        resp.associateOrg && setAssociateOrg(resp.associateOrg.id)
        setEmails(() => {
          if (resp.emails?.length) return resp.emails
          const orgEmails = Array.isArray(clinicOrg?.email) ? clinicOrg.email : (clinicOrg?.email ? [clinicOrg.email] : [])
          return orgEmails.length ? orgEmails : [user.email]
        })

        const { PatientName } = resp.PatientMainDicomTags
        document.title = PatientName

        setStudy(resp)
        updateAgeFields(resp.PatientMainDicomTags.PatientBirthDate)
      }).catch(e => e)
    }
    return () => {
      if (changeTimeout) {
        clearTimeout(changeTimeout)
        changeTimeout = undefined
      }
    }
  }, [params.studyId, study.id, user, updateOrg, updateAgeFields, defaultFields])

  useEffect(() => {
    const title = document.title;
    return () => document.title = title
  }, [])

  useEffect(() => {
    if (!orgs)
      GetOrg(access.org.id).then(resp => {
        const { orgs } = resp
        setOrgs((orgs.length && orgs) || orgsDefault)
      }).catch(e => e)
  }, [access.org.id, orgs]);

  useEffect(() => {
    if (!org && orgs?.length === 1 && study && !billing?.length && !priority)
      updateOrg(orgs[0].id) // There's only one org, so set it
  }, [org, orgs, study, billing, priority, updateOrg])

  useEffect(() => {
    const clinicOrgs = user.access && user.access.filter(e => e.clinic && (e.org.id !== access.org.id));
    clinicOrgs && clinicOrgs.length && setAssociateOrgs([access, ...clinicOrgs])

  }, [user.access, access])

  useEffect(() => {
    if (autoSave) {
      autoSaveRef.current = true
      updateConsult().then(() => {
        autoSaveRef.current = false
        console.log('Auto saved')
      })
      setAutoSave()
    }
  }, [updateConsult, autoSave])

  usePrompt("There are unsaved changes, are you sure you want to leave the page?", changes)

  const changeAssociateOrg = useCallback(id => {
    if (id && id !== "0") {
      const org = user.access?.find(a => a.org.id === id)
      const { email, users } = org?.org
      const updateAssoc = () => {
        setAssociateOrg(id)
        const orgEmails = Array.isArray(email) ? email : (email ? [email] : [])
        setEmails(orgEmails.length ? orgEmails : [])
        setClinicRequestees(!!users?.length && users)
      }
      const hasConsultFields = Array.isArray(org?.org?.settings?.consultFields) && org.org.settings.consultFields.length
      const hasMobileConsultFields = mobileStudy && Array.isArray(org?.org?.settings?.mobileConsultFields) && org.org.settings.mobileConsultFields.length
      clinicFields.current = hasMobileConsultFields || hasConsultFields
      const consultFields = (hasMobileConsultFields ? org.org.settings.mobileConsultFields.map(label=>({label})) : (hasConsultFields && org.org.settings.consultFields.map(label=>({label}))) || defaultFields)
      if (!mobileFields && !compareFields(consultFields, content)) // New fields don't match
        if (content.length && content.filter(e=>e.ref?.current).some(e=>!isEditorEmpty(e.ref.current)))
          setConfirm(
            (i) =>
              (i = {
                open: true,
                text: `Selected organization has different fields which will override your consult data. Are you sure?`,
                callback: () => {
                  updateAssoc()
                  setContent(consultFields)
                }
              })
            )
        else {
          updateAssoc()
          setContent(consultFields)
        }
      else updateAssoc()
    }
  }, [content, user.access, defaultFields, mobileFields, mobileStudy])

  const doSend = useCallback((fn) => {
    const ca = orgSettings?.consultAlert
    const now = Date.now()
    if (ca?.text && ca?.start && ca.start <= now && (!ca.end || ca.end > now)) {
      pendingSendRef.current = fn
      setConsultAlertOpen(true)
    } else {
      fn()
    }
  }, [orgSettings])

  if (!study) return (consultError ? <Typography color="error">{consultError}</Typography> : <React.Fragment />);

  const mobileRequest = (study.mobile || study.imaging) && !study.instanceCount

  const setEditorRef = (index, ref) => {
    setContent(content => {
      content[index].ref = ref
      return content
    })
  }

  const editorChange = () => {
    if (!changeTimeout)
      changeTimeout = setTimeout(() => {
        setAutoSave(true)
        changeTimeout = undefined
      }, 15000)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    saveEmailOptions()
    updateConsult().then(() => goBack(-1))
  }

  const handleSaveDialog = () => {
    if (newField.length) {
      setContent((e) => [...e, { label: newField }])
      setOpen(false)
    }
  }

  const sendStudy = () => {
    saveEmailOptions()
    doSend(() => updateConsult().then(() => SendStudy(study.id).then(() => goBack(-1))))
  }

  const sendMobile = () => {
    saveEmailOptions()
    doSend(() => updateConsult().then(() => SendMobile(study.id).then(() => goBack(-1))))
  }

  const updateStudy = (e) => {
    setStudy((prev) => {
      let p = { ...prev },
        obj = e.target.name.split(".");
      if (obj.length > 1)
        if (obj[0] in p) p[obj[0]] = { ...p[obj[0]], [obj[1]]: e.target.value };
        else p[obj[0]] = { [obj[1]]: e.target.value };
      else p[obj[0]] = e.target.value;
      return p;
    });
  };

  const deleteField = (label, index) =>
    setConfirm(
      (i) =>
        (i = {
          open: true,
          text: `Are you sure you want to delete: ${label}?`,
          callback: () => {
            setContent(e => {
              const c = [...e]
              c.splice(index, 1)
              return c
            })
          }
        })
      )
  return (
    <Container>
      <form onSubmit={handleSubmit} noValidate>
        <Grid
          sx={{ mb: 2 }}
          container
        >
          {associateOrgs && (
            <FormControl sx={{ mb: 1 }} fullWidth variant="standard">
              <TextField
                id="associateOrg"
                value={associateOrg || ''}
                label="Referring Organization"
                onChange={e => changeAssociateOrg(e.target.value)}
                variant="standard"
                color="secondary"
                select
                focused
              >
                {associateOrgs.map(e => (
                  <MenuItem key={e.org.id} value={e.org.id}>
                    {e.org.name}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          )}
          {!edit && orgs && (
            <FormControl sx={{ mb: 1 }} fullWidth variant="standard">
              <TextField
                id="org"
                value={org || ''}
                label="Reporting Organization"
                onChange={e => updateOrg(e.target.value)}
                variant="standard"
                select
                required
              >
                {orgs.map((e) => (
                  <MenuItem key={e.id} value={e.id}>
                    {e.name}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          )}
          {!edit && requestees?.length && !orgSettings?.disableRequestee ? (
            <FormControl fullWidth variant="standard" sx={{ mb: 1 }}>
              {!requestee ? (
                <>
                  <InputLabel shrink htmlFor="requestee-readonly">
                    Requestee
                  </InputLabel>
                  <Input
                    id="requestee-readonly"
                    value="First Available"
                    readOnly
                    onClick={e=>e.shiftKey && setRequestee([])}
                    endAdornment={
                      <IconButton onClick={e=>setRequestee(e.shiftKey ? [] : (clinicRequestees ? requestees.filter(e=>clinicRequestees.includes(e.id)) : requestees))} size="small" edge="end">
                        <EditIcon fontSize="small" />
                      </IconButton>
                    }
                  />
                </>
              ) : (
                <Autocomplete
                  id="requestees"
                  freeSolo={false}
                  multiple
                  name="requestees"
                  options={requestees}
                  filterSelectedOptions
                  getOptionLabel={o => o.name}
                  onChange={(e, v) => setRequestee(v)}
                  value={requestee}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" label="Requestees" />
                  )}
                />
              )}
            </FormControl>
          ) : null}
          {(customPriorities ? customPriorities.some(p => study.mobile ? p.mobile : !p.mobile) : (priorities && !!priorities.length)) && (
            <FormControl sx={{ mb: 1 }} fullWidth variant="standard">
              <TextField
                id="priority"
                value={priority === null || priority === undefined ? '' : priority}
                label="Priority"
                onChange={e => setPriority(e.target.value)}
                variant="standard"
                select
                required
              >
                {customPriorities ? (
                  [<MenuItem key="" value=""></MenuItem>,
                  ...customPriorities.filter(p => study.mobile ? p.mobile : !p.mobile).sort((a, b) => a.sortOrder - b.sortOrder).map(p => (
                    <MenuItem key={p.id} value={p.id}>
                      {p.name}
                    </MenuItem>
                  ))]
                ) : (
                  PRIORITIES.filter(e => !e.id || priorities.includes(e.id)).map((e) => (!e.hidden &&
                    <MenuItem key={e.id} value={e.id}>
                      {e.name}
                    </MenuItem>
                  ))
                )}
              </TextField>
            </FormControl>
          )}
          {billingCodes && !!billingCodes.length && (
            <FormControl sx={{ mb: 1 }} fullWidth variant="standard">
              <Autocomplete
                id="billing"
                freeSolo={false}
                multiple
                name="billing"
                options={billingCodes}
                filterSelectedOptions
                getOptionLabel={o => o.name}
                onChange={(e, v) => setBilling(v)}
                value={billing}
                isOptionEqualToValue={(o, v) => !orgSettings?.duplicateBillingCodes && o.id === v.id}
                renderInput={(params) => (
                  <TextField {...params} variant="standard" required={orgSettings?.requireBilling} label="Billing Codes" />
                )}
              />
            </FormControl>
          )}
          <FormControl sx={{ mb: 1 }} fullWidth variant="standard">
            <Autocomplete
              id="emails"
              freeSolo={true}
              multiple
              name="emails"
              filterSelectedOptions
              options={emailOptions}
              value={emails || []}
              clearOnBlur={true}
              onBlur={e => {
                const val = e.target?.value?.trim()
                val && emailTest.test(val) && setEmails(e => [...e, val])
              }}
              onChange={(e, v) => setEmails(v.map(e => e.trim()).filter(e => emailTest.test(e)))}
              renderInput={(params) => (
                <TextField {...params} variant="standard" label="Reporting Emails" />
              )}
            />
          </FormControl>
          <FormControl fullWidth variant="standard">
            <TextField
              id="numImages"
              value={numImages || ''}
              disabled={numImagesUnknown}
              label="Expected Number of Images"
              onChange={e => setNumImages(e.target.value)}
              onWheel={(e) => e.target.blur()}
              variant="standard"
              required
              inputProps={{ type: 'number', min: 0 }}
              helperText={!numImagesUnknown && numImages && parseInt(numImages) !== expectedNumImages && `${expectedNumImages} images currently received`}
              sx={{ "& .MuiFormHelperText-root": { color: 'warning.main' } }}
            />
          </FormControl>
          <FormGroup>
            <FormControlLabel control={<Checkbox />} label="Unknown" checked={numImagesUnknown} onChange={e => setNumImagesUnknown(e.target.checked)} />
          </FormGroup>
        </Grid>
        <Paper variant="outlined" sx={{ p: 1, mb: 4, width: 600 }}>
          <Grid
            sx={{ mt: 1, mb: 1 }}
            container
            spacing={3}
          >
            <FormControl fullWidth variant="standard">
              <TextField
                name="MainDicomTags.StudyDescription"
                label="Study Description (ie. Thorax XR, Head CT, Abdominal US)"
                value={study.MainDicomTags.StudyDescription || ""}
                onChange={updateStudy}
                required
              />
            </FormControl>
            <FormControl fullWidth variant="standard">
              <TextField
                name="MainDicomTags.ReferringPhysicianName"
                label="Referring Physician"
                value={study.MainDicomTags.ReferringPhysicianName || ""}
                required={orgSettings?.requirePhysician}
                onChange={updateStudy}
                helperText="If entered, will appear on report"
              />
            </FormControl>
            <FormControl fullWidth variant="standard">
              <TextField
                name="PatientMainDicomTags.ResponsiblePerson"
                label="Owner Name"
                value={study.PatientMainDicomTags.ResponsiblePerson || ""}
                onChange={updateStudy}
                required
              />
            </FormControl>
            <FormControl fullWidth variant="standard">
              <TextField
                name="PatientMainDicomTags.PatientName"
                label="Patient Name"
                value={study.PatientMainDicomTags.PatientName || ""}
                onChange={updateStudy}
                required
              />
            </FormControl>
            <FormControl fullWidth variant="standard">
              <TextField
                name="PatientMainDicomTags.PatientID"
                label="Patient ID"
                value={study.PatientMainDicomTags.PatientID || ""}
                onChange={updateStudy}
                required
              />
            </FormControl>
            <FormControl fullWidth variant="standard">
              <TextField
                id="gender"
                value={study.PatientMainDicomTags.PatientSex || ''}
                name="PatientMainDicomTags.PatientSex"
                label="Gender"
                variant="outlined"
                onChange={updateStudy}
                select
                required
              >
                {GENDER_OPTIONS.map((gender) => (
                  <MenuItem key={gender.key} value={gender.val}>
                    {gender.key}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
            <Grid container size={12} spacing={1}>
              <FormControl fullWidth variant="standard">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    name="PatientMainDicomTags.PatientBirthDate"
                    label="Birthdate/Age"
                    slotProps={{
                      textField: {
                        required: true,
                      },
                    }}                    
                    value={(study.PatientMainDicomTags.PatientBirthDate && dayjs(study.PatientMainDicomTags.PatientBirthDate)) || null}
                    onChange={newValue => {
                      const formattedDate = newValue ? moment(newValue.$d).format("YYYYMMDD") : ''
                      updateValues(formattedDate, "PatientMainDicomTags.PatientBirthDate")
                      updateAgeFields(formattedDate)
                    }}
                    textField={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </FormControl>
              <Grid size={4}>
                <TextField
                  value={ageYears}
                  onChange={e => {
                    setAgeYears(e.target.value)
                    updateBirthDateFromAge(e.target.value, ageMonths, ageDays)
                  }}
                  helperText="Years"
                  inputProps={{ type: 'number', min: 0 }}
                />
              </Grid>
              <Grid size={4}>
                <TextField
                  value={ageMonths}
                  onChange={e => {
                    setAgeMonths(e.target.value)
                    updateBirthDateFromAge(ageYears, e.target.value, ageDays)
                  }}
                  helperText="Months"
                  inputProps={{ type: 'number', min: 0 }}
                />
              </Grid>
              <Grid size={4}>
                <TextField
                  value={ageDays}
                  onChange={e => {
                    setAgeDays(e.target.value)
                    updateBirthDateFromAge(ageYears, ageMonths, e.target.value)
                  }}
                  helperText="Days"
                  inputProps={{ type: 'number', min: 0 }}
                />
              </Grid>
            </Grid>
            <FormControl fullWidth variant="standard">
              <Autocomplete
                id="species"
                freeSolo
                name="PatientMainDicomTags.PatientSpeciesDescription"
                options={SPECIES_OPTIONS}
                fullWidth
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                value={study.PatientMainDicomTags.PatientSpeciesDescription}
                getOptionLabel={(option) => option}
                onChange={(event, value) => {
                  updateValues(
                    value,
                    "PatientMainDicomTags.PatientSpeciesDescription"
                  )
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Species" required />
                )}
              />
            </FormControl>
            <FormControl fullWidth variant="standard">
              <TextField
                name="PatientMainDicomTags.PatientBreedDescription"
                label="Breed"
                value={study.PatientMainDicomTags.PatientBreedDescription || ""}
                onChange={updateStudy}
                required
              />
            </FormControl>
            <FormControl fullWidth variant="standard">
              <TextField
                type="number"
                name="PatientMainDicomTags.PatientWeight"
                label="Weight (kgs)"
                value={study.PatientMainDicomTags.PatientWeight || ""}
                onChange={updateStudy}
                onWheel={(e) => e.target.blur()}
                required
                inputProps={{ type: 'number', min: 0 }}
              />
            </FormControl>
          </Grid>
        </Paper>
        <Grid
          sx={{ mb: 3, mt: 3 }}
          container
          spacing={4}
          justifyContent="left"
        >
          {content?.map((item, index) => (
            <FormControl key={item.label || index} fullWidth variant="standard">
              <Grid container direction="row">
                <Grid size={11}>
                  <Typography component="h2" variant="h6" color={(item.label && item.label[0] === '*' && 'secondary') || 'default'}>
                    {(item.label ? (item.label[0] === '*' && item.label.slice(1)) || item.label : '')}:
                  </Typography>
                </Grid>
                <Grid size={1}>
                  <Button color="inherit" onClick={()=> deleteField(item.label, index)}>
                    <DeleteIcon />
                  </Button>
                </Grid>
              </Grid>
              <RichText
                onEditorRef={ref => setEditorRef(index, ref)}
                initialValue={item.html || '<p></p>'}
                onEditorChange={editorChange}
              />
            </FormControl>
          ))}
        </Grid>
        <Grid container sx={{ mb: 3 }} spacing={3} justifyContent="center">
          <FormControl fullWidth variant="standard">
            <Button color="secondary" onClick={()=> setOpen(true)} startIcon={<TextFieldsIcon />}>
              Add Field
            </Button>
          </FormControl>
          <Dialog open={open} maxWidth="sm" fullWidth onClose={()=> setOpen(false)}>
            <DialogTitle>Add Field</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Add a rich text field to the report for this study
              </DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                id="desc"
                label="Field Name"
                type="desc"
                fullWidth
                variant="standard"
                onChange={(e) => setNewField(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleSaveDialog}>Save</Button>
              <Button onClick={()=> setOpen(false)}>Cancel</Button>
            </DialogActions>
          </Dialog>
        </Grid>
        <FileDrop media={media} setMedia={setMedia} />
        <Grid container spacing={3} justifyContent="left">
          <Button variant="outlined" color="primary" type="submit" startIcon={<SaveIcon />}>
            Save
          </Button>
          {!edit && !(orgSettings?.disableClinicSend && !user.access.some(e=>e.org.id===org && (e.consult || e.admin))) && (
            <Button
              variant="contained"
              color="secondary"
              disabled={!completeRequired}
              onClick={mobileRequest ? sendMobile : sendStudy}
              startIcon={<SendIcon />}
              sx={{ "&:disabled": { backgroundColor: 'rgba(206, 147, 216, 0.25)' } }}
            >
              {mobileRequest ? 'Request' : 'Send'}
            </Button>
          )}
        </Grid>
      </form>
      <Confirmation
        open={confirm.open}
        onCancel={confirmCancel}
        onConfirm={confirmOk}
      >
        {confirm.text}
      </Confirmation>
      <ConsultAlertDialog
        open={consultAlertOpen}
        text={orgSettings?.consultAlert?.text}
        onClose={() => { setConsultAlertOpen(false); if (pendingSendRef.current) { pendingSendRef.current(); pendingSendRef.current = null } }}
      />
    </Container>
  );
};

export default StudyConsult;
